/**
 * FindPasswordResultContainer
 * --
 */
import React, { useState, useEffect, useRef } from 'react';
import FindPasswordResultPresenter from './FindPasswordResultPresenter';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUpdateGuestUser } from 'hooks/UserHooks';
import { passwordCheck } from 'utils/Validation';
import MessageAlert, { getCookie, removeCookie } from 'utils';

const FindPasswordResultContainer = (props) => {
  /* ===== ROUTE ===== */
  const location = useLocation();
  const navigate = useNavigate();

  /* ===== PROPS ===== */
  const { screenSize } = props;

  /* ===== MUTATE ===== */
  const { updateGuestUser } = useUpdateGuestUser();

  /* ===== STATE ===== */
  const passwordRef = useRef(null);
  const rePasswordRef = useRef(null);
  const [inputValue, setInputValue] = useState({
    password: '',
    re_password: '',
  });
  // Input 상태값
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('default');

  const [isSave, setIsSave] = useState(false);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**
   * 데이터 바인딩 함수
   * --
   */
  const handleChange = (t, v, callback = null) => {
    let newData = { ...inputValue };

    newData[t] = v;
    const d = {
      ...newData,
    };
    setInputValue(d);

    if (callback) callback(v);
  };

  /**
   * 비밀번호 재설정
   * --
   */
  const handleSubmit = async () => {
    const { password, re_password } = inputValue;

    if (!password) {
      setMessage('변경하실 비밀번호를 입력해주세요!');
      setStatus('error');
      passwordRef.current.focus();
      return;
    }

    if (!re_password) {
      setMessage('변경하실 비밀번호를 다시 한번 입력해주세요!');
      setStatus('error');
      rePasswordRef.current.focus();
      return;
    }

    if (password !== re_password) {
      setMessage('비밀번호가 일치하지 않습니다!');
      setStatus('error');
      passwordRef.current.focus();
      return;
    }

    if (!passwordCheck(password, setMessage)) {
      setStatus('error');
      passwordRef.current.focus();
      return;
    }

    try {
      const { status } = await updateGuestUser({
        password: password,
      });

      if (status !== 200) {
        MessageAlert.warning('비밀번호 변경에 실패하였습니다.');
        return;
      }

      window.alert(
        '비밀번호가 성공적으로 변경되었습니다.\n변경하신 비밀번호로 로그인해주세요.',
      );

      const isNative = window.ReactNativeWebView;
      if (isNative) window.ReactNativeWebView.postMessage('close');
      else navigate('/signin');
    } catch (err) {
      console.log('비밀번호 변경 오류', err);
      return;
    }
  };

  /* ===== HOOKS ===== */
  /**
   * Navigate State 값 처리
   * --
   */
  useEffect(() => {
    const resultData = location.state?.findValue;

    if (resultData) {
      const { data } = resultData;

      console.log('data ===>', data);
      // NOTE: 쿠키 저장 시간 설정
      const saveTime = 5 * 60 * 1000; // 5m
      removeCookie('JM_COFFEE_ACCESS_TOKEN', data, saveTime);

      setIsSave(true);
    } else {
      window.alert('잘못된 접근입니다!');
      navigate('/main');
    }
  }, []);

  /**
   * 쿠키 저장 후 인증시간 만료여부 확인
   * --
   */
  React.useEffect(() => {
    const getToken = getCookie('JM_COFFEE_ACCESS_TOKEN');

    if (isSave && !getToken) {
      window.alert('인증 시간이 만료되었습니다!');
      navigate(-1);
    }
  }, [isSave, navigate]);

  /* ===== RENDER ===== */
  return (
    <>
      <FindPasswordResultPresenter
        onChange={handleChange}
        inputValue={inputValue}
        passwordRef={passwordRef}
        rePasswordRef={rePasswordRef}
        message={message}
        status={status}
        onSubmit={handleSubmit}
        screenSize={screenSize}
      />
    </>
  );
};

export default FindPasswordResultContainer;
